import { render, staticRenderFns } from "./ModuleSettingsDialog.vue?vue&type=template&id=c841806c&scoped=true"
import script from "./ModuleSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ModuleSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettingsDialog.vue?vue&type=style&index=0&id=c841806c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c841806c",
  null
  
)

export default component.exports